import React from "react";

export default function Welcome() {
	return (
		<div>
			<h1 className=" font-fascinate text-8xl font-bold uppercase">Hello !</h1>
		</div>
	);
}
